<template lang="pug"></template>

<script>
import BotaoGestaoOperacoes from '@/components/botoesMenu/BotaoGestaoOperacoes';
import BotaoFiscalizacaoOperacoes from '@/components/botoesMenu/BotaoFiscalizacaoOperacoes';
import BotaoDashboardOperacoes from '@/components/botoesMenu/BotaoDashboardOperacoes';

export default {
    name: 'BotaoOperacao',
    componentOptions: {
        title: 'Operação',
        actions: [
            [
                {
                    name: 'Operação',
                    iconClass: 'lyra-icon lyra-money-alt',
                    showView: false,
                    action: 'abrirOperacoes',
                    route: 'operacao',
                    nameTranslationKey: 'mensagens.menuLateral.operacao',
                    submenus: [
                        BotaoGestaoOperacoes,
                        BotaoFiscalizacaoOperacoes,
                        BotaoDashboardOperacoes
                    ]
                }
            ]
        ]
    },

    methods: {
        abrirOperacoes() {
            if (this.$route.name !== 'operacao') {
                this.$router.push({ name: 'operacao' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
